export const PLANNER_MAP_LAYOUT_VARIANTS = {
  SIDEPANEL: 'sidepanel',
  EXTENDED: 'extended'
}

const DEFAULT_PLANNER_APP_CAPABILITIES = {
  showTransportFilter: true,
  showOperatorFilter: true,
  mapLayoutVariant: PLANNER_MAP_LAYOUT_VARIANTS.SIDEPANEL
}

export const PLANNER_APP_CAPABILITIES = {
  vl: {
    allowedTransports: ['BUS', 'SUBWAY', 'RAIL', 'BICYCLE_RENT', 'BICYCLE', 'TAXI', 'CAR', 'MOTORCYCLE', 'WALK'],
    mapLayoutVariant: PLANNER_MAP_LAYOUT_VARIANTS.EXTENDED
  },
  gc: {
    allowedTransports: ['BUS', 'WALK'],
    showOperatorFilter: false,
    mapLayoutVariant: PLANNER_MAP_LAYOUT_VARIANTS.EXTENDED
  },
  mr: {
    showTransportFilter: false,
    showOperatorFilter: false,
    mapLayoutVariant: PLANNER_MAP_LAYOUT_VARIANTS.EXTENDED
  }
}

export const ALLOWED_TRANSPORT_BY_APP = Object.keys(PLANNER_APP_CAPABILITIES).reduce((acc, appCode) => {
  if (PLANNER_APP_CAPABILITIES[appCode].allowedTransports) {
    acc[appCode] = PLANNER_APP_CAPABILITIES[appCode].allowedTransports
  }
  return acc
}, {})

export function getPlannerAppCapabilities(appCode) {
  return {
    ...DEFAULT_PLANNER_APP_CAPABILITIES,
    ...(PLANNER_APP_CAPABILITIES[appCode] || {})
  }
}

export function getAllowedPlannerTransports(appCode) {
  return PLANNER_APP_CAPABILITIES[appCode]?.allowedTransports
}

export function getDefaultSelectedPlannerTransports(appCode) {
  return PLANNER_APP_CAPABILITIES[appCode]?.defaultSelectedTransports ||
    PLANNER_APP_CAPABILITIES[appCode]?.allowedTransports
}

export function shouldShowPlannerTransportFilter(appCode) {
  return getPlannerAppCapabilities(appCode).showTransportFilter
}

export function shouldShowPlannerOperatorFilter(appCode) {
  return getPlannerAppCapabilities(appCode).showOperatorFilter
}

export function getPlannerMapLayoutVariant(appCode) {
  return getPlannerAppCapabilities(appCode).mapLayoutVariant
}
